import MileageDetailsRequest from "../../../api/raily/mileage/details/mileage-details.request";
import MileageDetailsParams from "./mileage-details-params";

const create = (params: MileageDetailsParams): MileageDetailsRequest => {
  return {
    mileageUuid: params.mileageUuid,
  };
};

const mileageDetailsParamsFactory = {
  create,
};

export default mileageDetailsParamsFactory;
